import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Tabs extends Component {

    static SILENT = true

    options = {
        anchors: false,
        tabs: '.Tabs li:not(.Tabs-item--label)',
        panels: '.TabPanel'
    }

    constructor(element) {
        super(element)

        if (this.element.dataset.options) {
            const options = JSON.parse(this.element.dataset.options) || {}

            this.options = {
                ...this.options,
                ...options
            }
        }

        this.current = null
    }

    prepare() {
        const tabElements = queryAll(this.options.tabs, this.element)
        this.panels = queryAll(this.options.panels, this.element)
            .reduce((acc, element) => {
                acc[element.id] = {
                    id: element.id,
                    element: element
                }

                element.removeAttribute('id')
                return acc
            }, {})

        this.tabs = tabElements.map(element => {
            const anchor = element.querySelector('a')
            const control = element.querySelector('select')
            let panelIds = []

            if (anchor) {
                panelIds.push(anchor.getAttribute('href').replace('#', ''))
                element.addEventListener('click', event => {
                    event.preventDefault()

                    if (element.dataset.action === 'show-all') {
                        this.showAll(element)
                    } else if (!element.classList.contains('.is-disabled')) {
                        this.show(panelIds[0])
                    }
                })
            }

            if (control) {
                panelIds = queryAll('option', element)
                    .map(option => option.value)

                control.addEventListener('change', event => this.show(control.value))
                element.addEventListener('click', event => {
                    if (!element.classList.contains(STATES.ACTIVE)) {
                        this.show(control.value)
                    }
                })
            }
            return {
                panelIds,
                element
            }
        })


        const fragment = window.location.hash.replace('#', '')

        if (fragment && fragment in this.panels) {
            this.show(fragment, Tabs.SILENT)
        } else {
            let defaultTab = this.tabs.filter(tab => tab.element.classList.contains(STATES.ACTIVE))[0]

            if (!defaultTab) {
                defaultTab = this.tabs[0]
            }

            if (defaultTab.element.dataset.action === 'show-all') {
                this.showAll(defaultTab.element)
            } else {
                this.show(defaultTab.panelIds[0], Tabs.SILENT)
            }
        }

        EventBus.on('tabs:show', this.handleTabsShow)
        window.addEventListener('hashchange', this.handleHashChange)

    }

    destroy() {
        EventBus.off('tabs:show', this.handleTabsShow)
        window.removeEventListener('hashchange', this.handleHashChange)
    }

    handleHashChange = event => {
        const id = window.location.hash.replace('#', '')

        if (id !== this.current && id in this.panels) {
            this.show(id, Tabs.SILENT)
        }
    }

    handleTabsShow = ({ panelId }) => {
        this.show(panelId)
    }

    showAll(trigger) {
        this.tabs
            .filter(tab => tab.element !== trigger)
            .forEach(tab => tab.element.classList.remove(STATES.ACTIVE))
        trigger.classList.add(STATES.ACTIVE)

        Object.keys(this.panels)
            .forEach(key => {
                this.panels[key].element.classList.add(STATES.ACTIVE)
            })

        EventBus.emit('tabs:change')
    }

    show(panelId, silent = false) {

        if (!(panelId in this.panels)) {
            return
        }

        this.current = panelId

        const panel = this.panels[panelId]

        Object.keys(this.panels)
            .filter(key => this.panels[key].id !== panel.id)
            .forEach(key => {
                this.panels[key].element.classList.remove(STATES.ACTIVE)
            })

        panel.element.classList.add(STATES.ACTIVE)

        this.tabs.forEach(tab => {
            if (tab.panelIds.includes(panelId)) {
                tab.element.classList.add(STATES.ACTIVE)
            } else {
                tab.element.classList.remove(STATES.ACTIVE)
            }
        })

        if (this.options.anchors && !silent){
            window.location.hash = panelId
        }

        this.emit('change', {
            panelId,
            panel
        })

        EventBus.emit('tabs:change', {
            panelId,
            panel
        })

        return this

    }
}